import styled from 'styled-components';

export const InboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  .view-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;
